import { useTranslation } from 'react-i18next';
import usePopUp from 'src/hook/modal/usePopUp';
import { IconLocation } from '../../../../utils/URLUtils';
import styles from './ProBlurred.module.scss';

interface ProBlurredProps {
    children: React.ReactNode;
    show: boolean;
}

const ProBlurred = ({ children, show }: ProBlurredProps) => {
    const { t } = useTranslation();
    const { showProPopUp } = usePopUp();

    const handleProClick = () => {
        showProPopUp(t('Pro Tips'), t("Master every word's correct application for total English confidence."));
    };

    return (
        <div className={styles.container}>
            {children}
            {show && (
                <div className={styles.proOverlay}>
                    <div className={styles.proButton} onClick={handleProClick}>
                        <img src={IconLocation('lock', true)} alt={t('Lock')} />
                        <span>{t('Get Pro')}</span>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProBlurred;
